import FormUtil from "../util/FormUtil";
import ExternalLogger from "../logger/ExternalLogger";
import EDeliveryEvents from "./event/EDeliveryEvents";

const EDeliveryInlineController = function ($scope, eventBus, EDeliveryFactory) {
    var vm = this,
        logger = ExternalLogger.getInstance("EDeliveryInlineController");

    // Available communication preference options
    vm.CommunicationPreference = EDeliveryFactory.CommunicationPreferences;

    // The participant's chosen communication preference
    vm.communicationPreference = null;

    // The participant's chosen email address
    vm.emailChoice = null;

    /**
     * Check whether or not we should show the e-delivery directive.
     *
     * @return {Boolean} True to show the e-delivery directive; false otherwise
     */
    vm.showEDelivery = function () {
        return EDeliveryFactory.getAllowedToOverwrite();
    };

    /**
     * Update the selected e-delivery option in the factory when the participant
     * makes a change so we can access the selected value in the parent view (i.e.
     * Registration Summary or Enrollment Confirmation).
     */
    vm.onChangeEDelivery = function () {
        EDeliveryFactory.setSelectedEDeliveryOption(vm.communicationPreference);

        eventBus.dispatch(EDeliveryEvents.E_DELIVERY_CHECKBOX, this);
    };

    /**
     * Get the document types to display. Returns an object that will be used to interpolate
     * the translation for 'summary.eDelivery.documentsInclude'.
     
     * @return {Object} The interpolation object for the document types content.
     */
    vm.getDocTypes = function () {
        return {
            documentTypes: EDeliveryFactory.getDocTypes()
        };
    };

    /**
     * Check whether or not we should show the document types.
     *
     * @return {Boolean} True to show the document types; false otherwise
     */
    vm.showDocTypes = function () {
        return EDeliveryFactory.getDocTypes() !== null;
    };

    /**
     * Check whether or not the email address dropdown should be displayed.
     *
     * @return {Boolean} True to show the email address dropdown; false otherwise
     */
    vm.showEmailDropdown = function () {
        return vm.getEmailChoices().length > 1;
    };

    /**
     * Check whether or not the input to add a new email address should be displayed.
     *
     * @return {Boolean} True to show the email address input; false otherwise
     */
    vm.showEmailInput = function () {
        return vm.getEmailChoices().length === 0 || !vm.getEmailChoices().length;
    };

    /**
     * Check whether or not an email address is required.
     *
     * @return {Boolean} True if an email address is required; false otherwise
     */
    vm.isEmailRequired = function () {
        return vm.communicationPreference === vm.CommunicationPreference.EDELIVERY_ONLY;
    };

    /**
     * Return the name errors, of a field in a form
     **/
    vm.getFieldError = function (fieldName) {
        return FormUtil.getFieldError($scope.eConsentForm, fieldName);
    };

    /**
     * Return true if field is dirty
     **/
    vm.isDirty = function (fieldName) {
        return FormUtil.isDirty($scope.eConsentForm, fieldName);
    };

    /**
     * Return error class name if field is dirty and has any error
     **/
    vm.getFormGroupClass = function (fieldName) {
        return FormUtil.getFormGroupClass($scope.eConsentForm, fieldName);
    };

    /**
     * Get the available email addresses for the participant (i.e. personal and/or work email).
     *
     * @return {Array} A list of email addresses on file for the participant
     */
    vm.getEmailChoices = function () {
        return EDeliveryFactory.getEmailChoices();
    };

    $scope.removeInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = false;
    };

    $scope.setInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = true;
        $scope.accountSetupForm[event.target.name].$setTouched(true);
        $scope.accountSetupForm[event.target.name].$setDirty(true);
    };

    /**
     * Update the selected email address in the factory when the participant
     * makes a change so we can access the selected value in the parent view (i.e.
     * Registration Summary or Enrollment Confirmation).
     */
    vm.onChangeEmail = function () {
        if (vm.showEmailDropdown) {
            //dropdown
            EDeliveryFactory.setSelectedEmail(vm.emailChoice);
            eventBus.dispatch(EDeliveryEvents.EMAIL_CHOICE, this);
        } else {
            //input
            if ($scope.eConsentForm.$valid) {
                EDeliveryFactory.setSelectedEmail(vm.emailChoice);
                eventBus.dispatch(EDeliveryEvents.EMAIL_CHOICE, this);
            }
        }
    };

    // Initialize the controller
    (function init() {
        var allowed = EDeliveryFactory.getAllowedToOverwrite();

        if (!allowed) {
            logger.error(
                "E-delivery not allowed or EDeliveryFactory has not been hydrated for group id {0}",
                [EDeliveryFactory.getGaId()]
            );
            return false;
        }

        // Always select e-delivery for Registration Summary and Enrollment Confirmation
        // // Honor the preference if the participant has selected "e-delivery and by mail"
        // if (EDeliveryFactory.getEDeliveryOption() === vm.CommunicationPreference.EDELIVERY_AND_MAIL) {
        //     vm.communicationPreference = vm.CommunicationPreference.EDELIVERY_AND_MAIL;
        // } else {
        // Otherwise default to "e-delivery"
        vm.communicationPreference = vm.CommunicationPreference.EDELIVERY_ONLY;
        // }

        // Set the selected option to the default preference
        EDeliveryFactory.setSelectedEDeliveryOption(vm.communicationPreference);

        vm.emailChoice = EDeliveryFactory.getSelectedEmail();
    })();

    $scope.$watch("eConsentForm", function (newValue) {
        EDeliveryFactory.setForm(newValue);
    });
};

EDeliveryInlineController.$inject = ["$scope", "eventBus", "EDeliveryFactory"];
export default EDeliveryInlineController;
